var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenbullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7555 23.8067C40.7555 33.3053 33.0553 41.0055 23.5567 41.0055C14.0581 41.0055 6.35791 33.3053 6.35791 23.8067C6.35791 14.3081 14.0581 6.60791 23.5567 6.60791C26.2551 6.60791 28.8084 7.22934 31.0812 8.33689M37.5307 13.0575L22.4818 28.1064L18.1821 23.8067",
    stroke: "#6BBE66",
    strokeWidth: 4.58635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenbullet);
export default __webpack_public_path__ + "static/media/greenbullet.417599abb49639dffd980571e142759b.svg";
export { ForwardRef as ReactComponent };